export default __webpack_public_path__ + "static/media/image00014.bfd89821.jpeg";